import {useEffect,useState} from 'react';
import axios from 'axios';
import {serverHost} from '../http_common.js';
export function useCOOData(sessionToken,path,params={}){
 const [state,setState]=useState({data:null,loading:true,error:''});
 const [version,setVersion]=useState(0);
 const search=JSON.stringify(params);
 useEffect(()=>{
  if(!sessionToken||!path){setState({data:null,loading:false,error:''});return;}
  const ctrl=new AbortController();let alive=true;
  setState(previous=>({...previous,loading:true,error:''}));
  axios.get(`${serverHost}/coo/operations/${path}`,{
    headers:{Authorization:`Bearer ${sessionToken}`},params:JSON.parse(search),signal:ctrl.signal,timeout:30000
  }).then(({data})=>{if(alive)setState({data:data.data,loading:false,error:''});})
    .catch(error=>{if(alive&&!axios.isCancel(error))setState(previous=>({...previous,loading:false,error:error.response?.data?.message||'Operational records are temporarily unavailable.'}));});
  return()=>{alive=false;ctrl.abort();};
 },[sessionToken,path,search,version]);
 return {...state,refresh:()=>setVersion(v=>v+1)};
}
export const count=v=>Number.isFinite(v)?new Intl.NumberFormat('en-NG').format(v):'—';
export const date=v=>v?new Date(v).toLocaleDateString('en-NG',{timeZone:'Africa/Lagos',day:'numeric',month:'short',year:'numeric'}):'—';
